


















































































































































































































































































































import {Component, Prop, Emit, Vue, Watch, PropSync} from 'vue-property-decorator';
import DSelectbox from "@/components/DSelectbox/selectbox.vue";
import {DxCheckBox} from 'devextreme-vue/check-box';
import {DxLoadIndicator} from 'devextreme-vue/load-indicator';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTagBox from 'devextreme-vue/tag-box';
import DButton from '@/components/DButton/button.vue';
import Nebalans from '@/components/HeaderSet/Nebalans.vue';
import _, { includes } from 'lodash';
import InputSettings from '@/components/HeaderSet/InputSettings.vue';
import PeriodTreeSelect from '@/components/PeriodTreeSelect/period-tree-select.vue';
import PeriodTreeSelectNew from '@/components/PeriodTreeSelect/PeriodTreeSelectNew.vue';

import {
  Period,
  UserPreset,
  YearType,
  CutType,
  EcoObjectType,
  Accept,
  IAcceptResponse,
  EcoFilialSelectionType,
  EcoNodeSelectionType
} from '@/services/models-service';
import dicts_cache_service from '@/services/dicts_cache_service';
import PresetService from '@/services/user_preset_service';
import YearService from '@/services/years-service';
import cutService from '@/services/cut-service';
import ShareService from '@/services/share-service';
import fillBlocksService from '@/services/fill-blocks-service';
import EcoObjectsService from '@/services/eco-objects-service';
import ImbalanceService from '@/services/imbalance_service';
import UserAccessService from '@/services/user_access_service';
import AuthService from '@/services/auth_service';
import {months_map, route_accept_map, periods} from "@/constants";
import {alert} from 'devextreme/ui/dialog';
import acceptService from '@/services/accept-service';
import UserManagerService, {User} from "@/services/data/user_manager";
import login from "@/views/login/index.vue";
import {aggregate_periods} from '@/constants';
import WebSocketService from '@/services/websocket_service';
import {format5DigitsVariant} from '@/utils/numbers';
import {getImbalanceStyleColor} from "@/utils/getImbalanceStyleColor";
import DPeriodTreeSelect from "@/components/PeriodTreeSelect/DPeriodTreeSelect.vue";
import TreeDropDownBox from "@/components/TreeDropDownBox/tree-drop-down-box.vue";
import TreeDropDownBoxSingleCheck from "@/components/TreeDropDownBox/tree-drop-down-box-single-check.vue";
import TreeDropDownBoxSingleCheckCutsList from "@/components/TreeDropDownBox/tree-drop-down-box-single-check-cuts-list.vue";
import { off } from 'devextreme/events';

interface EcoFacilitySelectionType {
  id: number;
  name: string;
  check: boolean;
  object_type_id: number;
  date_from?: string | null;
}

interface CutsList {
  year_id: string;
  year_name: number;
  nodes: {
    name: string;
    id: string;
    strong_tariff_calc: boolean;
    check: boolean;
    disabled: boolean;
  }[];
}

// Интерфейс для кеша акцептов
interface CacheEntry {
  data: IAcceptResponse;
  timestamp: number;
}

// Функция для группировки period_ds в дерево
function buildPeriodTree(period_ds: any[]) {
  const periodGroups = [
    {
      id: 'months',
      label: 'Месяцы',
      filter: (p: any) => [
        'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'
      ].includes(p.name)
    },
    {
      id: 'quarters',
      label: 'Кварталы',
      filter: (p: any) => p.display && /квартал/i.test(p.display)
    },
    {
      id: 'halfyears',
      label: 'Полугодия',
      filter: (p: any) => p.display && /полугодие/i.test(p.display)
    },
    {
      id: 'year',
      label: 'Год',
      filter: (p: any) => p.display && /^год$/i.test(p.display)
    },
    {
      id: 'growth',
      label: 'Нарастание',
      filter: (p: any) => p.display && /мес\./i.test(p.display) && /\(/.test(p.display)
    },
    {
      id: 'wane',
      label: 'Убывание',
      filter: (p: any) => p.display && /мес\./i.test(p.display) && /\(/.test(p.display)
    }
  ];
  return periodGroups.map(group => ({
    id: group.id,
    label: group.label,
    children: period_ds.filter(group.filter).map((p: any) => ({
      id: p.name,
      label: p.display
    }))
  })).filter(group => group.children.length > 0);
}

@Component({
  name: 'HeaderSet',
  components: {
    TreeDropDownBoxSingleCheckCutsList,
    TreeDropDownBoxSingleCheck,
    TreeDropDownBox,
    DPeriodTreeSelect,
    DSelectbox,
    DxSelectBox,
    DxCheckBox,
    DxTagBox,
    DxLoadIndicator,
    DButton,
    Nebalans,
    InputSettings,
    PeriodTreeSelect,
    PeriodTreeSelectNew,
  }
})
export default class extends Vue {
  @Prop({default: false}) public disableSaveButton!: boolean;
  @PropSync('changes') public changedData!: any;
  @Prop({
    default: () => {
      return []
    }
  }) public tariffsOnPage!: string[];


  public service = PresetService;
  public AcceptService = acceptService;
  public shareService = ShareService;
  public blockService = fillBlocksService;
  private cut_service = cutService;

  // источники данных для селектбоксов
  public year_ds: YearType[] = YearService.filteredYearList;
  public period_ds = dicts_cache_service.periods;
  public cut_ds: CutType[] = [];
  public cutsList: CutsList[] = [];
  public secondaryCutsList: CutsList[] = [];
  // Реактивное свойство для отслеживания изменений в кеше срезок
  private cutsCacheLength: number = 0;

  // доступность кнопки загрузить
  public availableLoad: boolean = true;
  public allowLoad: boolean = false;
  public allowRefresh: boolean = false;
  public periods: string[] = [];
  public isLoaded: boolean = false;

  // Доступность выбора филиала/узла/объекта
  public availableFillials: boolean = false;
  // Флаг обновления списка блоков заполненеия для данного объекта ТУ
  // необходимо дисэйбллить кнопку Загрузить, пока происходит актуализация списка доступных блоков заполнения
  public isFillBlockUploading = false;

  public imbalanceStruct: any = {
    total: {},
  };
  public imbalanceStructShowen: any = {
    total: {},
  }
  public currentImbalance: any = {};
  public cutName: string = '';
  public currentYear: number = 2000;

  // узлы доступные согласно настроек доступа
  public permission_nodes: any[] = [];
  // если роль оператор, тогда выбор селектбоксов недоступен
  public disableSelector: boolean = false;

  public yearAccepts: IAcceptResponse = {};
  public editableCuts: any[] = [];

  public showBlocks: any = {};

  public popupSettings: any = {
    visible: false,
  }

  public showImbalance: boolean = this.service.show_imbalance || false;
  public showFacility: boolean = true;
  public oneActiveCheck: boolean = true;
  private fetchPreset: boolean = false;
  public id_eco_filials: number[] = [];
  public id_eco_heat_nodes: number[] = [];
  public id_eco_facility: number | null = null;
  private selectionData: EcoFilialSelectionType[] = [];
  public ecoService = EcoObjectsService;
  public ignoreRootNodesList: string[] = ['months', 'quarters', 'halfyears', 'year_item', 'growth', 'wane'];
  public disabledSelector: boolean = false;

  private acceptsLoadingInProgress = false;
  private cutChangeTimeout: ReturnType<typeof setTimeout> | null = null;
  private acceptsCache = new Map<string, CacheEntry>();
  private acceptsCacheTTL = 10 * 60 * 1000; // 10 минут
  private cacheCleanupInterval: ReturnType<typeof setInterval> | null = null;
  private acceptReloadGuardUntil = 0;

  private triggerAcceptReload() {
    const now = Date.now();
    if (now < this.acceptReloadGuardUntil) {
      return;
    }

    // Один и тот же акцепт может прийти одновременно из локального state
    // и из websocket, поэтому поднять щиты.
    this.acceptReloadGuardUntil = now + 1000;
    this.onLoad();
  }

  @Watch('AcceptService.state.acceptChanges', {immediate: true})
  async onAcceptChangesChanged(newVal: any) {
    if (newVal === false) return;

      await this.loadAccepts();
      this.AcceptService.state.acceptChanges = false;
      if (this.service.currentPreset.period && this.service.currentPreset.period.length > 0 && this.service.currentPreset.id_year && this.service.currentPreset.id_cut && this.service.currentPreset.id_eco_filial && this.service.currentPreset.id_eco_heat_node && this.service.currentPreset.id_eco_facility) {
        this.triggerAcceptReload();
      }

  }

  @Watch('cutsCacheLength')
  onCutsCacheChanged() {
    if (this.isLoaded) {
      this.getCutsList();
    }
  }

  private createSelectionTreeStructure() {
    const tree = this.ecoService.filialNodesFacilitiesTree;
    if (!tree) {
      this.selectionData = [];
      return;
    }

    const selectionData: EcoFilialSelectionType[] = [];

    // Объект ЕСО может в переходный период попасть сразу в два тепловых узла
    // (например, при смене ТУ - см. п. 231 реестра замечаний). Не даём ему
    // задвоиться в списке выбора - добавляем только при первой встрече.
    const seenFacilityIds = new Set<number>();

    for (const filialUid in tree) {
      if (!Object.prototype.hasOwnProperty.call(tree, filialUid)) continue;
      const filialData = (tree as any)[filialUid];

      // Собираем узлы (тепловые узлы) для данного филиала
      const nodes: EcoNodeSelectionType[] = [];
      for (const nodeUid in filialData.nodes) {
        if (!Object.prototype.hasOwnProperty.call(filialData.nodes, nodeUid)) continue;
        const nodeData = (filialData.nodes as any)[nodeUid];

        // Преобразуем объекты ТУ в массив facilities
        const facilities: EcoFacilitySelectionType[] = (
          nodeData.objects?.objects || []
        ).filter((obj: any) => {
          if (!obj || seenFacilityIds.has(obj.id)) {
            return false;
          }
          seenFacilityIds.add(obj.id);
          return true;
        }).map((obj: any) => ({
          id: obj.id,
          name: obj.name,
          object_type_id: obj.object_type_id,
          check: this.service.currentPreset.id_eco_facility === obj.id,
          date_from: obj.date_from
        })).sort((a: EcoFacilitySelectionType, b: EcoFacilitySelectionType) => a.object_type_id - b.object_type_id)

        nodes.push({
          id: Number(nodeUid),
          name: nodeData.name,
          check: false,
          date_from: nodeData.date_from,
          facilities // если showFacility=true, компонент их отрисует
        });
      }

      selectionData.push({
        id: Number(filialUid),
        name: filialData.name,
        check: false,
        date_from: filialData.date_from,
        nodes
      });
    }
    this.selectionData = selectionData;
  }

  private hasFacilityInSelection(facilityId: number | null): boolean {
    if (!facilityId) {
      return false;
    }

    for (const filial of this.selectionData) {
      for (const node of filial.nodes || []) {
        if ((node.facilities || []).some((facility: any) => facility.id === facilityId)) {
          return true;
        }
      }
    }
    return false;
  }

  private mergeTreesByFacilitiesUnion(primaryTree: any, secondaryTree: any) {
    const mergedTree: any = _.cloneDeep(primaryTree || {});

    const mergeFromSource = (sourceTree: any) => {
      for (const filialUid in sourceTree) {
        if (!Object.prototype.hasOwnProperty.call(sourceTree, filialUid)) continue;
        const sourceFilial = sourceTree[filialUid];
        if (!mergedTree[filialUid]) {
          mergedTree[filialUid] = {
            ...sourceFilial,
            nodes: {}
          };
        }

        if (!mergedTree[filialUid].nodes) {
          mergedTree[filialUid].nodes = {};
        }

        for (const nodeUid in sourceFilial.nodes) {
          if (!Object.prototype.hasOwnProperty.call(sourceFilial.nodes, nodeUid)) continue;
          const sourceNode = sourceFilial.nodes[nodeUid];
          const sourceFacilities = sourceNode.objects?.objects || [];

          if (!mergedTree[filialUid].nodes[nodeUid]) {
            mergedTree[filialUid].nodes[nodeUid] = _.cloneDeep(sourceNode);
            continue;
          }

          const targetNode = mergedTree[filialUid].nodes[nodeUid];
          const targetFacilities = targetNode.objects?.objects || [];
          const facilityById = new Map<number, any>();

          targetFacilities.forEach((obj: any) => {
            if (obj?.id) {
              facilityById.set(obj.id, obj);
            }
          });

          sourceFacilities.forEach((obj: any) => {
            if (obj?.id && !facilityById.has(obj.id)) {
              facilityById.set(obj.id, obj);
            }
          });

          targetNode.objects = {
            ...(targetNode.objects || {}),
            objects: Array.from(facilityById.values())
          };
        }
      }
    };

    mergeFromSource(secondaryTree || {});
    return mergedTree;
  }

  @Watch('service.currentPreset.id_cut', {immediate: true})
  async onCutChanged() {
    this.disabledSelector = true;
    this.fetchPreset = true;
    if (!this.isLoaded) {
      if (!this.service.currentPreset.id_cut) {
        this.selectionData = [];
      } else {
        this.createSelectionTreeStructure();
      }
      Vue.nextTick(() => {
        this.fetchPreset = false;
        this.disabledSelector = false;
      });
      return;
    }

    if (!this.service.currentPreset.id_cut) {
      this.selectionData = [];
    } else {
      await this.updateFilialNodesTree();
      this.createSelectionTreeStructure();
    }
    Vue.nextTick(() => {
      this.fetchPreset = false;
      this.disabledSelector = false;
    });
  }

  async updateFilialNodesTree() {
    this.availableFillials = false;
    this.service.currentPreset.id_year = this.findYearIdByCutId(this.cutsList, this.service.currentPreset.id_cut)
    const year = this.getYear(this.year_ds) || null;
    const months = this.getMonthList();
    const version = this.currentCut?.id_eco_version;
    console.log('updateFilialNodesTree', {version, year, months});

    if (version !== undefined && year && months.length > 0) {
      const primaryTree = await this.ecoService.get_facilities_tree(Number(version), year.name, months);
      let mergedTree = primaryTree;

      if (primaryTree && this.service.currentPreset.id_secondary_cut) {
        const secondaryCut = this.cut_ds.find(c => c.id === this.service.currentPreset.id_secondary_cut);
        const secondaryYearId = this.findYearIdByCutId(this.cutsList, this.service.currentPreset.id_secondary_cut);
        const secondaryYear = this.year_ds.find((y: YearType) => y.id === secondaryYearId);
        const secondaryVersion = secondaryCut?.id_eco_version;

        if (secondaryVersion !== undefined && secondaryYear) {
          const secondaryTree = await this.ecoService.get_facilities_tree(Number(secondaryVersion), secondaryYear.name, months);
          if (secondaryTree) {
            mergedTree = this.mergeTreesByFacilitiesUnion(primaryTree, secondaryTree);
          }
        }
      }

      this.ecoService.filialNodesFacilitiesTree = mergedTree || {};
      this.availableFillials = !!mergedTree;
    } else {
      this.ecoService.filialNodesFacilitiesTree = {};
      this.availableFillials = false;
    }
  }

  private findVersionByCutId(cutId: string | null): number | null {
    if (!cutId) return null;
    return dicts_cache_service.cuts.find((cut : any) => cut.id === cutId)?.id_eco_version || null;
  }

  onHierarchyChanged({filials, nodes, facilities}: {
    filials: number[];
    nodes: number[];
    facilities: number[];
  }) {
    this.service.currentPreset.id_eco_facility = facilities.length ? facilities[0] : null;
    this.service.currentPreset.id_eco_heat_node = nodes.length ? nodes[0] : null;
    this.service.currentPreset.id_eco_filial = filials.length ? filials[0] : null;
  }

  getYear(year_ds: any[]) {
    return year_ds.find((y: YearType) => y.id === this.service.currentPreset.id_year)
  }

  getMonthList() {
    const periodsList = this.periods.slice().filter(p => !this.ignoreRootNodesList.includes(p));
    let month_set: any[] = [];

    periodsList.forEach((period_name: string) => {
      const prd = this.period_ds.find((period: any) => {
        return period.name === period_name
      });

      if (prd) {
        const m = prd.months;
        month_set = prd.months.slice()
      }
    })

    return Array.from(new Set(month_set));
  }

  @Watch('showImbalance')
  onImbalanceShowChange(val: boolean) {
    console.log(this.showImbalance)
    this.service.show_imbalance = val
    this.service.currentPreset.show_imbalance = val
    console.log(this.service.currentPreset)
    console.log("preset", this.service.show_imbalance)
    // this.$emit('onShowImbalance', val);
  }

  get currentCut(): CutType | undefined {
    return dicts_cache_service.cuts.find((cut : any) => cut.id === this.service.currentPreset.id_cut)
  }

  get cut_secondary_ds(): CutType[] {
    if (!this.currentCut) return [];
    const {id_eco_version, id} = this.currentCut;
    // фильтрация по соответствующей основной срезке ЕСО версии
    return this.cut_ds.filter(c =>
      c.id !== id
    );
  }

  // Добавляем значение '-' для сброса выбора доп. срезки
  get cutSecondaryWithNone() {
    const result: any[] = [];
    const secondaryCuts = this.cut_secondary_ds;
    if (secondaryCuts && secondaryCuts.length > 0) {
      for (const cut of secondaryCuts) {
        result.push(cut);
      }
    }
    return result;
  }

  // Проверяем, выбрана ли дополнительная срезка (не null и не '-')
  get hasSecondaryCut() {
    const hasCut = this.service.currentPreset.id_secondary_cut &&
      this.service.currentPreset.id_secondary_cut !== null;
    return hasCut;
  }

  // Получаем объект дополнительной срезки
  get secondaryCut() {
    if (this.hasSecondaryCut) {
      const cut = this.cut_ds.find(c => c.id === this.service.currentPreset.id_secondary_cut);
      return cut;
    }
    return null;
  }

  get route() {
    return this.$route.name
  }

  get loadButtonText() {
    if (this.isFillBlockUploading) {
      return 'Загрузка данных'
    }
    return 'Загрузить'
  }

  get imbalanceMonths() {
    let result = [];
    for (let period of this.service.currentPreset.period){
      if (!aggregate_periods.hasOwnProperty(period)){
        result.push(period)
      }

    }
    return result
  }

  get periodName() {
    let name = '';
    if (this.service.currentPreset.period && this.service.currentPreset.period.length === 1) {
      const period_match = this.period_ds.find((period: any) => period.name === this.service.currentPreset.period[0]);
      name = period_match.display;
    } else {
      let aggregatePeriods: any = [];
      this.service.currentPreset.period?.forEach((period: string) => {
        if (aggregate_periods.hasOwnProperty(period)) {
          aggregatePeriods.push(period)
        }
      });
      if (aggregatePeriods.length === 1) {
        const period_match = this.period_ds.find((period: any) => period.name === aggregatePeriods[0]);
        name = period_match.display;
      }
    }
    return name;
  }

  async created() {
    if (this.route) {
      this.permission_nodes = UserAccessService.checkReading(this.route);
      if (this.permission_nodes.length === 0) {
        alert('Нет доступных для чтения тепловых узлов', 'Обратитесь к администратору');
      }
      if (!_.isNil(sessionStorage.getItem(`table_width`))) {
        const match = sessionStorage.getItem(`table_width`);
        if (match) {
          const settings = JSON.parse(match);
          if (settings.user_id === localStorage.getItem('user_id')) {
            this.service.tableWidth = settings.width;
            this.service.cardWidth = settings.card_width;
          }
        }
      }
    }
    if (this.$options.sockets) {
      this.$options.sockets.onmessage = (data: any) => {
        let res = WebSocketService.handleMsg(data, 'finish_recalc_after_tariff');
        if (!_.isNil(res)) {
          if (this.route === 'losses') {
            return
          }
          if (res.success) {
            this.isNeedToUpdateData(res)
          }
          return;
        }

        // Обработка обновления списка срезок
        res = WebSocketService.handleMsg(data, 'cuts_update');
        if (!_.isNil(res)) {
          // Обновляем кеш срезок и затем обновляем список в компоненте
          dicts_cache_service.loadCuts().then(() => {
            // Обновляем реактивное свойство, что вызовет Watch и обновит список
            this.cutsCacheLength = dicts_cache_service.cuts.length;
          });
          return;
        }
      }
    }

    this.isLoaded = false;
    this.year_ds = _.cloneDeep(YearService.filteredYearList);

    await this.loadDataFromServer();
    // Инициализируем отслеживание длины кеша срезок
    this.cutsCacheLength = dicts_cache_service.cuts.length;
    this.getCutsList();
    this.seekCutName();

    this.isLoaded = true;
    await this.updateFilialNodesTree();
    this.createSelectionTreeStructure();

    await this.getBlocks();

    // Запуск периодической очистки кеша
    this.cacheCleanupInterval = setInterval(() => {
      this.cleanupExpiredCache();
    }, 5 * 60 * 1000); // каждые 5 минут

    if (this.service.currentPreset.period && this.service.currentPreset.period.length > 0 && this.service.currentPreset.id_year && this.service.currentPreset.id_cut && this.service.currentPreset.id_eco_filial && this.service.currentPreset.id_eco_heat_node && this.service.currentPreset.id_eco_facility) {
      this.onLoad();
    }
  }

  mounted() {
  }

  private async isNeedToUpdateData(res: any) {
    if (res.id_cut === this.service.currentPreset.id_cut && res.object_ids.includes(this.service.currentPreset.id_eco_facility)) {
      for (let id_str in res.tariff_ids) {
        if (this.tariffsOnPage.includes(res.tariff_ids[id_str])) {
          await alert(`Был выполнен пересчет данных после изменения тарифов, будет выполнена перезагрузка`, 'Внимание');
          this.emitAfterRecalc();
          this.onLoad();
          break
        }
      }
    }
  }

  private async isNeedToUpdateLoadAcceptsHandle(): Promise<boolean> {
    // Если срезка и объект ТУ в текущем пресете и акцептированных данных совпадают, произвести поиск по месяцам и блокам
    if (this.isLoaded &&
      this.service.currentPreset.id_cut &&
      this.cut_service.acceptChanges?.cut_id == this.service.currentPreset.id_cut &&
      this.service.currentPreset.id_eco_facility &&
      this.cut_service.acceptChanges.data.hasOwnProperty(this.service.currentPreset.id_eco_facility)) {
      // Список месяцев из текущих выбранных, для которых было произведено акцептирование
      let intersectingMonths = []
      for (const stringPeriod of this.service.currentPreset.period) {
        const intPeriod = months_map[stringPeriod]
        if (intPeriod && this.cut_service.acceptChanges.months.includes(intPeriod)) {
          intersectingMonths.push(stringPeriod)
        }
      }
      if (intersectingMonths.length === 0) {
        return false
      }
      const blockData = this.cut_service.acceptChanges.data[this.service.currentPreset.id_eco_facility]
      // Список акцептированных полей в зависимости от текущей страницы ввода
      const acceptBlockList = route_accept_map[this.route || '']
      if (acceptBlockList?.length) {
        for (const acceptedField of acceptBlockList) {
          if (blockData.hasOwnProperty(acceptedField)) {
            await alert(`Было произведено акцептирование срезки ${this.cutName} для текущего объекта ТУ, будет выполнена перезагрузка`, "Внимание")
            this.AcceptService.state.acceptChanges = true
            return true
          }
        }
      }
    }
    return false
  }

  async loadAccepts() {
    // Предотвращаем одновременную загрузку
    if (this.acceptsLoadingInProgress) {
      console.log('[Accepts] Loading already in progress, skipping...');
      return;
    }
    console.log('[Accepts] 1');

    this.yearAccepts = {};
    this.$emit('acceptLoaded', false);
    this.acceptsLoadingInProgress = true;

    const acceptYearID = this.service.currentPreset.id_year || '';
    const initialCutID = this.service.currentPreset.id_cut || '';

    if (!acceptYearID || !initialCutID) {
      console.warn('Invalid preset data');
      this.acceptsLoadingInProgress = false;
      return;
    }
    console.log('[Accepts] 2');

    const initialCut = this.cut_ds.find((cut: CutType) => cut.id === initialCutID);
    if (!initialCut) {
      console.warn('Initial cut not found');
      this.acceptsLoadingInProgress = false;
      return;
    }
    console.log('[Accepts] 3');

    try {
      console.log("[Accepts] 4")
      const acceptResp = await this.fetchAcceptWithFilterMemoized(acceptYearID, [{
        cut_id: initialCut.id,
        version_id: initialCut.id_eco_version
      }]);
      console.log("[Accepts] 5")

      if (acceptResp) {
        this.yearAccepts = acceptResp;
        this.getEditableCuts();
      }
      console.log('[Accepts] Loaded accepts for year', acceptYearID);
    } catch (error) {
      console.error('Error loading accepts:', error);
    } finally {
      acceptService.SetAcceptDict(this.yearAccepts, acceptYearID);
      this.$emit('acceptLoaded', true);
      this.acceptsLoadingInProgress = false;
    }
  }

  // ========== МЕТОД: Мемоизированная загрузка акцептов ==========
  private async fetchAcceptWithFilterMemoized(
    yearID: string,
    cuts: any[]
  ): Promise<IAcceptResponse> {
    const cacheKey = this.generateCacheKey(yearID, cuts);

    // Проверяем кеш
    const cached = this.acceptsCache.get(cacheKey);
    if (cached && (Date.now() - cached.timestamp) < this.acceptsCacheTTL && this.AcceptService.state.acceptChanges === false) {
      console.log('[Accepts] Using cached data for', cuts.map(c => c.cut_id).join(', '));
      return cached.data;
    }

    // Загружаем с сервера
    console.log('[Accepts] Fetching from server:', cuts.map(c => c.cut_id).join(', '));
    const data = await this.fetchAcceptWithFilter(yearID, cuts);

    // Кешируем результат
    this.acceptsCache.set(cacheKey, {
      data,
      timestamp: Date.now()
    });

    return data;
  }

  // ========== МЕТОД: Генератор ключа кеша ==========
  private generateCacheKey(yearID: string, cuts: any[]): string {
    const cutIds = cuts.map(c => c.cut_id).sort().join('|');
    return `${yearID}:${cutIds}`;
  }

  // ========== МЕТОД: Очистка устаревшего кеша ==========
  private cleanupExpiredCache() {
    const now = Date.now();
    let cleanedCount = 0;
    for (const [key, value] of this.acceptsCache.entries()) {
      if (now - value.timestamp > this.acceptsCacheTTL) {
        this.acceptsCache.delete(key);
        cleanedCount++;
      }
    }
    if (cleanedCount > 0) {
    }
  }

  public clearAcceptsCache() {
    this.acceptsCache.clear();
  }

  public getAcceptsCacheStats() {
    return {
      size: this.acceptsCache.size,
      entries: Array.from(this.acceptsCache.keys()),
      ttl: this.acceptsCacheTTL
    };
  }

  private async fetchAcceptWithFilter(yearID: string, cuts: any[]): Promise<IAcceptResponse> {
    const params = {year_id: yearID, cuts: cuts};
    return await acceptService.getWithFilter(params);
  }

  getEditableCuts() {
    try {
      this.editableCuts = [];
      this.cut_ds.forEach((cut: any) => {
        if (this.months_list.length > 0 && this.service.currentPreset.id_eco_facility) {
          if (this.yearAccepts[cut.id] && !this.editableCuts.includes(cut.id)) {
            this.months_list.forEach((mon: number) => {
              const match = this.yearAccepts[cut.id].find((acc: Accept) => acc.id_eco_facility === this.service.currentPreset.id_eco_facility && acc.month === mon)
              if (!match || !match.full_accept) this.editableCuts.push(cut.id);
            });
          }
          if (!this.yearAccepts[cut.id] && !this.editableCuts.includes(cut.id)) {
            this.editableCuts.push(cut.id);
          }
        }
      });
    } catch (error) {
      console.log(this.cut_ds);
      console.error("Ошибка при выполнении блока getEditableCuts:", error);
    }
  }

  async loadDataFromServer() {
    this.service.loadPreset();

    const today = new Date();
    if (!this.service.currentPreset.id_year) {
      const current_year = Number(today.getFullYear());
      const default_year = this.year_ds.find(y => y.name === current_year);
      if (default_year) {
        this.service.currentPreset.id_year = default_year.id;
      }
    }
    this.shareService.share_year_id = this.service.currentPreset.id_year;
    this.shareService.share_cut_id = this.service.currentPreset.id_cut;

    if (!this.service.currentPreset.period || this.service.currentPreset.period.length < 1) {
      const current_mounth = today.toLocaleString("en-US", {month: 'long'},).toLowerCase();
      const default_period: Period = dicts_cache_service.periods.find((p: Period) => p.name === current_mounth);
      this.periods = [default_period.name];
      this.service.currentPreset.period = this.periods;

    } else {
      const all_periods = periods.concat(Object.keys(aggregate_periods))
      this.periods = this.service.currentPreset.period;
      this.periods.sort(function (a: string, b: string) {
        return all_periods.indexOf(a) - all_periods.indexOf(b);
      });

    }

    this.getCutsYear();
    await this.loadAccepts();
  }

  async getImbalance() {
    if (this.service.currentPreset.id_cut && this.service.currentPreset.id_eco_facility) {
      const imbalance_resp = await ImbalanceService.getStruct(this.service.currentPreset.id_cut, this.service.currentPreset.id_eco_facility, this.service.currentPreset.period);
      if (imbalance_resp) {
        this.imbalanceStruct = _.cloneDeep(imbalance_resp);
        this.imbalanceStructShowen = _.cloneDeep(imbalance_resp)
      }
    }
    const periodsList = this.periods.slice().filter(p => !this.ignoreRootNodesList.includes(p));
    periodsList.forEach(period => {
      if (!aggregate_periods.hasOwnProperty(period)){
        this.calculateImbalance(period)
      }
    })
    periodsList.forEach(period => {
      if (aggregate_periods.hasOwnProperty(period) && period !== 'year'){
        this.calculateAggImbalance(period)
      }
    })
  }

  calculateAggImbalance(period: string){
    const safeNumber = (val: any): number => {
      if (val === null || val === undefined) return 0;
      const num = typeof val === 'number' ? val : Number(val);
      return Number.isFinite(num) ? num : 0;
    };

    for (let row in this.imbalanceStructShowen[period]) {
      let total_row = 0
      for( let aggPeriod of aggregate_periods[period]){
        const value = safeNumber(this.imbalanceStruct.year[aggPeriod]?.[row]);
        total_row += value;
      }
      this.imbalanceStructShowen[period][row] = total_row
    }
  }

  calculateImbalance(period: string) {
    const inc_keys = ['loss_ok', 'purchase_vendors', 'purchase_vno', 'purchase_vgo']
    const dec_keys = ['loss_hn', 'loss_tp', 'loss_kp', 'loss_tso_p', 'sale_end_user_k', 'sale_end_user_p', 'sale_gvs', 'sale_vno', 'sale_vgo', 'sale_vgo23']

    const safeNumber = (val: any): number => {
      if (val === null || val === undefined) return 0;
      const num = typeof val === 'number' ? val : Number(val);
      return Number.isFinite(num) ? num : 0;
    };

    for (let row in this.imbalanceStruct[period]) {
      let row_total = 0
      for (let key in this.imbalanceStruct[period][row]) {
        const value = safeNumber(this.imbalanceStruct[period][row][key]);
        if (inc_keys.includes(key)) {
          row_total += value;
        } else if (dec_keys.includes(key)) {
          row_total -= value;
        }
      }
      this.imbalanceStructShowen[period][row] = row_total;
      this.imbalanceStructShowen.year[period][row] = row_total;
    }
    let steam_total = 0
    for (let i = 2; i < 7; i++){
      const value = safeNumber(this.imbalanceStructShowen[period][i]);
      steam_total += value;
    }
    this.imbalanceStructShowen[period][7] = steam_total
    this.imbalanceStructShowen.year[period][7] = steam_total

    this.$emit('imbalanceReady', this.imbalanceStructShowen)
  }

  @Watch('changedData', {deep: true})
  recalcImbalance(data: any) {
    if(Object.keys(data).length === 0) {
      this.getImbalance();
      return
    }
    const month = this.changedData?.total?.month;
    if (!month) {
      return
    }

    let prefix = '';
    if (this.$route.name === 'buy') {
      prefix = 'purchase_';
    } else if (this.$route.name === 'losses') {
      prefix = 'loss_';
    } else {
      prefix = `${this.$route.name}_`;
    }
    for (let key in data) {
      if (key !== 'total' && data[key]) {
        const element = prefix + data[key].block;
        if (this.imbalanceStruct[data[key].month]) {
          if (this.imbalanceStruct[data[key].month][this.stringToNumber(key)]) {
            this.imbalanceStruct[data[key].month][this.stringToNumber(key)][element] = data[key].vol_te;
          } else {
            this.imbalanceStruct[data[key].month][this.stringToNumber(key)] = {[element]: data[key].vol_te};
          }
        }
      }
    }
    this.calculateImbalance(month);
  }

  @Watch('imbalanceStructShowen.year', {deep: true})
  calculateImbalanceTotal() {
    // console.log("QWERTYUI")
    this.currentImbalance = {};
    const result: any = {};
    const total_result: any = {};
    for (let step = 1; step < 8; step++) {
      result[step] = 0;
      total_result[step] = 0;
    }

    const safeNumber = (val: any): number => {
      if (val === null || val === undefined) return 0;
      const num = typeof val === 'number' ? val : Number(val);
      return Number.isFinite(num) ? num : 0;
    };

    for (let month in this.imbalanceStruct.year) {
      for (let key in this.imbalanceStruct.year[month]) {
        const value = safeNumber(this.imbalanceStructShowen.year[month][key]);
        total_result[key] += value;
        if (this.imbalanceMonths.includes(month)) {
          result[key] += value;
        }
      }
    }
    if (this.imbalanceMonths.length > 0) this.currentImbalance = result;
    console.log('currentImbalance', this.currentImbalance)
    this.imbalanceStructShowen.total = total_result;
  }

  get months_list(): number[] {
    const periodsList = this.periods.slice().filter(p => !this.ignoreRootNodesList.includes(p));
    this.service.currentPreset.period = periodsList;
    let months = new Set();
    let months_list: number[] = [];
    const year_months = new Set(aggregate_periods.year);
    for (let month of this.service.currentPreset.period) {
      if (year_months.has(month)) {
        months.add(month)
      } else {
        const arr = aggregate_periods[month];
        for (const m of (Array.isArray(arr) ? arr : [])) {
          months.add(m);
        }
      }

      if (months.size === 12) {
        break
      }
    }

    this.service.uniqueMonths = Array.from(months);
    this.service.uniqueMonths.sort(this.sortPeriods);

    if (this.service.uniqueMonths) {
      this.service.uniqueMonths.forEach((m: any) => {
        if (months_map[m]) {
          months_list.push(months_map[m]);
        }
      })
    }
    return months_list;
  }

  @Emit('onSave')
  onSave() {

  }

  @Emit('onExport')
  async onExport() {
    if (!(_.isEmpty(this.changedData) || this.disableSaveButton)) {
      await alert('Имеются несохраненные изменения, для получения файла с актуальными данными нажмите кнопку "Сохранить"', 'Внимание');
    }
  }

  @Watch('service.currentPreset.id_year')
  async changeYear() {
    if (!this.isLoaded) {
      return;
    }

    // Очищаем кеш при смене года
    this.acceptsCache.clear();

    this.shareService.share_year_id = this.service.currentPreset.id_year;
    this.getCutsYear();
  }

  private findYearIdByCutId(cuts: CutsList[], cutId: string | null): string | null {
    for (const cut of cuts) {
      if (cut.nodes.some(node => node.id === cutId)) {
        return cut.year_id;
      }
    }
    return this.service.currentPreset.id_year || null;
  }

  private onCutRestored(cutId: string) {
    this.$nextTick(async () => {
      await this.updateFilialNodesTree();
      await this.createSelectionTreeStructure();
    });
  }

  @Watch('service.currentPreset.id_cut')
  async onChangeCut() {
    this.service.currentPreset.id_year = this.findYearIdByCutId(this.cutsList, this.service.currentPreset.id_cut)
    if (!this.isLoaded) {
      return;
    }

    // Отменяем предыдущий timeout
    if (this.cutChangeTimeout) {
      clearTimeout(this.cutChangeTimeout);
    }

    if (this.currentCut) {
      // если была выбрана доп. срезка и она не соответствует по ЕСО версии основной - сброс
      if (this.service.currentPreset.id_secondary_cut) {
        const sec_cut = this.cut_secondary_ds.find((c: CutType) => {
          return c.id === this.service.currentPreset.id_secondary_cut
        })

        if (!sec_cut) {
          this.service.currentPreset.id_secondary_cut = null;
        }
      }

      // Дебаунс 300ms
      this.cutChangeTimeout = setTimeout(() => {
        this.loadAccepts();
      }, 300);
    }

    this.service.currentPreset.id_eco_filial = null;
    this.service.currentPreset.id_eco_heat_node = null;
    this.service.currentPreset.id_eco_facility = null;

    if (this.service.currentPreset.id_cut) {
      await this.updateFilialNodesTree();
      this.createSelectionTreeStructure();
    } else {
      this.selectionData = [];
    }
  }

  @Watch('service.currentPreset.id_secondary_cut')
  async onSecondaryCutChange() {
    if (!this.isLoaded) {
      return;
    }
    this.disabledSelector = true;
    await this.updateFilialNodesTree();
    this.createSelectionTreeStructure();

    if (!this.hasFacilityInSelection(this.service.currentPreset.id_eco_facility)) {
      this.service.currentPreset.id_eco_facility = null;
      this.service.currentPreset.id_eco_heat_node = null;
      this.service.currentPreset.id_eco_filial = null;
    }

    this.disabledSelector = false;
    // Эмитим информацию о дополнительной срезке при её изменении
    this.emitSecondaryCutInfo();
  }

  @Watch('service.currentPreset.id_eco_facility', {deep: true})
  async getBlocks() {
    let shouldResetLoading = false;
    try {
      this.getEditableCuts();

      if (!this.isLoaded || !this.service?.currentPreset?.id_eco_facility) return;

      let result: any = {
        ok_hn_blocks: [],
        purchase_blocks: [],
        sale_blocks: [],
        transport_income_blocks: [],
        transport_costs_blocks: [],
      };

      const {id_cut, id_year, id_eco_heat_node, id_eco_facility} = this.service.currentPreset;
      this.shareService.share_cut_id = id_cut;
      const year = this.year_ds.find((y: YearType) => y.id === id_year);
      if (this.currentCut?.id_eco_version && id_eco_heat_node && id_eco_facility && year && id_cut) {
        shouldResetLoading = true;
        this.isFillBlockUploading = true;
        this.currentYear = year.name;
        const resp = await this.blockService.getWithECOFilter(this.currentCut.id_eco_version, id_cut, id_eco_heat_node, year.name, this.months_list);

        let currentBlocks: any[] = [];
        let facilityName = '';

        if (resp) {
          const current = resp.find((fb: { facility: { id: number; name: string } }) => fb.facility.id === this.service.currentPreset.id_eco_facility);
          if (current) {
            currentBlocks = current.fill_blocks;
            facilityName = current.facility.name;
          }
        }

        currentBlocks.forEach((block: any) => {
          if (block.is_show === true) {
            if (result[block.block_group]) {
              result[block.block_group].push(block);
            } else {
              console.warn("[HeaderSet:getBlocks] Неизвестный блок в заданных настройках отображения:", block.block_group, block);
            }
          }
        });
        this.showBlocks = result;
        this.sendBlocks(this.showBlocks, facilityName);

        // Проверка какие месяцы отображать для объекта согласно его времени жизни
        if (id_eco_facility) {
          await EcoObjectsService.check_object_lifetime(this.currentCut.id_eco_version, year.id, id_eco_heat_node, [id_eco_facility]);
        }

      }
    } catch (error) {
      console.error("Ошибка при выполнении блока getBlocks:", error);
    } finally {
      if (shouldResetLoading) {
        this.isFillBlockUploading = false;
      }
    }
  }

  @Watch('service.currentPreset', {deep: true})
  seekPreset() {

    if (!this.isLoaded) {
      return;
    }

    this.service.preset_changed = true;

    this.availableLoad = true;
    if (this.service.currentPreset.id_cut && this.service.currentPreset.id_eco_filial && this.service.currentPreset.id_eco_heat_node && this.service.currentPreset.id_eco_facility && this.service.currentPreset.period?.length > 0) {
      this.allowLoad = true;
      this.allowRefresh = true;
    } else {
      this.allowLoad = false;
      this.allowRefresh = false;
    }

    this.shareService.share_year_id = this.service.currentPreset.id_year;
    this.shareService.share_cut_id = this.service.currentPreset.id_cut;
  }

  @Watch('periods')
  async changePeriods() {
    if (!this.isLoaded) {
      return;
    }
    this.disabledSelector = true;
    const periodsList = this.periods.slice().filter(p => !this.ignoreRootNodesList.includes(p));
    this.service.currentPreset.period = periodsList;

    // if (!this.service.currentPreset.period || this.service.currentPreset.period.length === 0) {
    //   this.selectionData = [];
    //   return;
    // }

    await this.updateFilialNodesTree();
    await this.createSelectionTreeStructure();
    this.disabledSelector = false;
  }

  getCutsList() {
    // Очищаем массивы перед заполнением, чтобы избежать дублирования при повторном вызове
    this.cutsList = [];

    for (let year of this.year_ds) {
      let nodes = dicts_cache_service.cuts
        .filter((c: any) =>
          c.id_year === year.id &&
          (c.visible_for === 'Видимый для администратора' || c.visible_for === 'Видимый для всех')
        )
        .map((c: any) => ({
          id: c.id,
          name: c.name,
          strong_tariff_calc: c.strong_tariff_calc,
          disabled: c.disabled
        })); // оставляем только нужные поля

      if (nodes.length > 0) {
        nodes = _.sortBy(nodes, (o) => o.number); // если number не нужен, можно убрать
        this.cutsList.push({
          year_id: year.id,
          year_name: year.name,
          nodes
        });
      }
    }
    this.secondaryCutsList = _.cloneDeep(this.cutsList)
  }

  getCutsYear() {
    if (this.service.currentPreset.id_year) {

      let filtered = dicts_cache_service.cuts.filter((c: any) => {
        if ((c.visible_for === 'Видимый для администратора' || c.visible_for === 'Видимый для всех')) {
          return c
        }
      })

      if (filtered) {
        filtered = _.sortBy(filtered, [(o) => o.number]);
        this.cut_ds = _.clone(filtered);
      }
    }
  }

  get facility_ds() {
    const res: Array<{ id: number|null; name: string; kind: 'node'|'facility', date_from: string }> = [];
    const tree: any = this.ecoService.filialNodesFacilitiesTree;

    const filialId = this.service.currentPreset.id_eco_filial;
    const nodeId = this.service.currentPreset.id_eco_heat_node;
    const facilityId = this.service.currentPreset.id_eco_facility;

    if (!tree || !filialId || !nodeId) {
      return res;
    }

    const filial = tree[String(filialId)];
    const node = filial?.nodes?.[String(nodeId)];
    if (node?.name) {
      res.push({ id: nodeId, name: node.name, kind: 'node', date_from: node.date_from });
    }

    if (facilityId && node?.objects?.objects?.length) {
      const f = node.objects.objects.find((o: any) => o.id === facilityId);
      if (f?.name) {
        res.push({ id: facilityId, name: f.name, kind: 'facility', date_from: f.date_from });
      }
    }

    return res;
  }


  sortPeriods(m1: string, m2: string) {
    return months_map[m1] - months_map[m2]
  }

  openPopup() {
    this.popupSettings.visible = true;
  }

  async confirmSave() {
    const entity = _.cloneDeep(this.service.currentPreset);
    const periods = JSON.stringify(this.periods);
    entity.period = periods;
    const result = await this.service.save(entity);
    let update_preset = new UserPreset();
    if (result) {
      let cache = localStorage.getItem('_cache_presets');
      if (cache) {
        let _cache_presets = JSON.parse(cache);
        let index = _cache_presets.findIndex((preset: UserPreset) => preset.id === result.id);
        if (index === -1) {
          _cache_presets.push(result);
        } else {
          _cache_presets.splice(index, 1, result);
        }
        localStorage.setItem('_cache_presets', JSON.stringify(_cache_presets));
        this.service.loadFromLocalStorage();
        let periods = [];
        if (result.period) {
          periods = JSON.parse(result.period);
        }
        update_preset = _.cloneDeep(result);
        update_preset.period = periods;
      }
    }

    this.service.preset_changed = false;
  }

  @Emit('onLoad')
  onLoadEmit() {
    this.emitFacilities();
  }

  @Emit('facilities')
  emitFacilities() {
      return this.facility_ds
  }

  onLoad() {
    this.disabledSelector = true;
    try {
      void this.months_list;

      if (
        EcoObjectsService.facilityLifetimeMap &&
        EcoObjectsService.facilityLifetimeMap[this.service.currentPreset.id_eco_facility as number]
      ) {
        this.service.period_filtered = this.service.uniqueMonths.filter((m: string) => {
          return EcoObjectsService.facilityLifetimeMap[this.service.currentPreset.id_eco_facility as number][months_map[m]];
        });
      }

      this.allowLoad = false;
      this.seekCutName();
      this.onLoadEmit();
      this.emitSecondaryCutInfo();
      ImbalanceService.getImbalanceColors()
      this.getImbalance();
      this.allowRefresh = true;
      this.confirmSave()
    } catch (error) {
      console.error("Ошибка при выполнении блока onLoad:", error);
    }
    this.disabledSelector = false;
  }

  @Emit('showBlocks')
  sendBlocks(blocks: any, facilityName: string) {
    return { blocks: blocks, facilityName: facilityName };
  }

  @Watch('cut_service.acceptIsChanged')
  async reloadAcceptData(value: boolean) {
    if (value) {
      const doReload = await this.isNeedToUpdateLoadAcceptsHandle()
      if (doReload) {
        // acceptChanges уже true — onAcceptChangesChanged загрузит свежие акцепты
        // (минуя кэш) и вызовет triggerAcceptReload один раз
        return
      }
      await this.loadAccepts()
    }
  }

  @Emit('cutName')
  seekCutName() {
    const result = {name: '', secondary: ''}
    if (this.currentCut) {
      this.cutName = this.currentCut.name;
      result.name = this.currentCut.name;
    }
    if (this.service.currentPreset.id_secondary_cut) {
      const secondary_cut = this.cut_ds.find(c => c.id === this.service.currentPreset.id_secondary_cut);
      if (secondary_cut) result.secondary = secondary_cut.name;
    }
    return result;
  }

  @Emit('secondaryCutInfo')
  emitSecondaryCutInfo() {
    const info = {
      hasSecondaryCut: this.hasSecondaryCut,
      secondaryCut: this.secondaryCut,
      secondaryCutId: this.service.currentPreset.id_secondary_cut
    };
    return info;
  }

  public stringToNumber(str: string) {
    const values: any = {
      first: 1,
      second: 2,
      third: 3,
      fourth: 4,
      fifth: 5,
      sixth: 6,
      total: 7,
    }

    return values[str]
  }

  public sortSelected(e: any) {
    const all_periods = periods.concat(Object.keys(aggregate_periods))
    const test = Array.isArray(e.value) ? e.value.slice() : [];
    test.sort(function (a: string, b: string) {
      return all_periods.indexOf(a) - all_periods.indexOf(b);
    });
    if (!_.isEqual(test, e.value)) {
      this.periods = test
    }
  }


  get show_export_excel_and_load() {
    if (this.route === 'losses' && this.service.currentPreset.losses_show_volume) {
      return false;
    }
    if (this.route === "buy" && (this.service.currentPreset.buy_show_volume || this.service.currentPreset.buy_show_cost || this.service.currentPreset.buy_show_price || this.service.currentPreset.buy_show_cost_delta ||
      this.service.currentPreset.buy_show_price_total || this.service.currentPreset.buy_show_cost_total)) {
      return false;
    }
    if (this.route === "sale" && (this.service.currentPreset.sale_show_volume || this.service.currentPreset.sale_show_cost || this.service.currentPreset.sale_show_price || this.service.currentPreset.sale_show_cost_delta ||
      this.service.currentPreset.sale_show_price_total || this.service.currentPreset.sale_show_cost_total)) {
      return false;
    }
    if (this.route === "transport_cost" && (this.service.currentPreset.transport_cost_show_volume || this.service.currentPreset.transport_cost_show_cost || this.service.currentPreset.transport_cost_show_price ||
      this.service.currentPreset.transport_cost_show_cost_delta || this.service.currentPreset.transport_cost_show_price_total || this.service.currentPreset.transport_cost_show_cost_total)) {
      return false;
    }
    if (this.route === "transport_gain" && (this.service.currentPreset.transport_gain_show_volume || this.service.currentPreset.transport_gain_show_cost || this.service.currentPreset.transport_gain_show_price ||
      this.service.currentPreset.transport_gain_show_cost_delta || this.service.currentPreset.transport_gain_show_price_total || this.service.currentPreset.transport_gain_show_cost_total)) {
      return false;
    } else {
      return true;
    }
  }

  tooltip(id: any, ds: any) {
    const current = ds.find((c: any) => c.id === id);
    if (current?.name) return current.name
    return ''
  }

  private destroyed(): void {
    if (this.$options.sockets) {
      delete this.$options.sockets.onmessage;
    }
    // Очищаем интервал при уничтожении компонента
    if (this.cacheCleanupInterval) {
      clearInterval(this.cacheCleanupInterval);
    }
  }

  @Emit('forceReload')
  emitAfterRecalc() {
    return true
  }

  get periodTreeData() {
    return buildPeriodTree(this.period_ds);
  }
}
